<template>
    <b-container fluid class="overview">
        <h1 class="text-left">{{ $t('menuItemBitmaps') }}</h1>
        <br />
        <!-- Overview Table -->
        <div>
            <b-table
                id="bitmapsoverview"
                striped
                hover
                small
                outlined
                bordered
                v-show="dataLoaded"
                @row-clicked="$_onDetails"
                :sort-by.sync="sortBy"
                :tbody-tr-class="$_rowClass"
                :items="logos"
                :fields="fields"
                sort-icon-left
            >
                <template v-slot:cell(imageData)="data">
                    <b-img
                        :src="data.item.imageData"
                        fluid
                        alt="Responsive image"
                    ></b-img>
                </template>
                <template v-slot:cell(imageType)="data">
                    <span>{{ $_getImageType(data.item.imageType) }}</span>
                </template>
            </b-table>
        </div>
        <!-- No content for overview -->
        <div v-show="noImagePresent" class="col-md-12">
            <span> &nbsp; {{ $t('noImagesPresent') }}</span>
        </div>
        <router-links-footer :routerLinks="[{ name: 'BitmapsDetailNew' }]" />
    </b-container>
</template>

<script>
    import RouterLinksFooter from '../../components/dashboard/RouterLinksFooter.vue';
    import { arrayNotEmpty } from '../../services/utilities';
    import { AVAILABLE_LOGO_TYPE } from '../../constants';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';

    export default {
        mixins: [modalMixin],

        components: {
            'router-links-footer': RouterLinksFooter
        },

        data() {
            return {
                logos: [],
                noImagePresent: false,
                fields: [
                    {
                        key: 'name',
                        label: this.$t('columnNameName'),
                        sortable: true,
                        stickyColumn: true,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'imageType',
                        label: this.$t('columnTypeTitle'),
                        sortable: true,
                        class: 'text-left',
                        thStyle: {
                            width: '70px',
                            border: 0
                        }
                    },
                    {
                        key: 'imageData',
                        label: 'Afbeelding',
                        sortable: false,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    }
                ],
                sortBy: 'name'
            };
        },

        computed: {
            dataLoaded() {
                return arrayNotEmpty(this.logos);
            }
        },

        mounted() {
            this.$_getOrganizationImages();
        },

        methods: {
            /*
             * Converts image data from base64 to string representation
             */
            $_convertImageData() {
                if (arrayNotEmpty(this.logos)) {
                    this.logos.forEach((image) => {
                        image.imageData = atob(image.imageData);
                        image.name = image.name || this.$t('noFilenameDefined');
                    });
                }
            },

            /**
             * Converts the imageType to its textual representation
             * @param imageType
             */
            $_getImageType(imageType) {
                return AVAILABLE_LOGO_TYPE[imageType - 1].text;
            },

            /*
             * Gets all defined bitmaps for organization
             */
            async $_getOrganizationImages() {
                await this.$store
                    .dispatch('useApiData', {
                        name: 'GetOrganizationLogos',
                        parameters: {
                            id: this.$store.getters.userInfo.organizationId
                        }
                    })
                    .then((result) => {
                        this.logos = Object.assign([], result.data);
                        this.$_convertImageData();
                        this.noImagePresent = this.logos.length === 0;
                    })
                    .catch((error) => {
                        const data = {
                            message: error.message,
                            variant: 'danger',
                            title: this.$t('imageGetFailedError'),
                            autoHideDelay: 5000
                        };
                        this.showToast(data);
                    });
            },

            /**
             * Navigates to edit view and sets the params
             * @param record
             */
            $_onDetails(record) {
                this.$router.push({
                    name: 'BitmapsDetail',
                    params: {
                        id: record.id,
                        metadata: record
                    }
                });
            },

            /*
             * Sets the class of a row
             */
            $_rowClass() {
                return 'tablerow';
            }
        }
    };
</script>

<style scoped>
.img-fluid {
    border: 1px solid #ddd !important;
    border-radius: 4px !important;
    padding: 5px !important;
    max-width: 100px !important;
    height: 35px !important;
}
</style>
